// extracted by mini-css-extract-plugin
module.exports = {"chooseRole":"chooseRole_chooseRole__3JNjt","selectBlock":"chooseRole_selectBlock__3g-5-","selectBlockItem":"chooseRole_selectBlockItem__3lBC4","logo":"chooseRole_logo__1tivb"};